/**
 * Extracts the last 4 digits from a masked PAN
 * @example
 * getLastFourDigits("412345******1293") // returns "1293"
 */
export const getLastFourDigits = (maskedPan: string): string => {
  return maskedPan.slice(-4);
};
